<template>
  <div class="contentA">
    <!-- 检查计划表  -->
    <!-- <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>检查计划</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col> -->
    <!-- </el-row> -->
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style="display:flex;justify-content: space-between;align-items: center;height:56px;padding:0 1vw;border-bottom: 2px solid #E7E7E7;" >
            <div class="grid-search" style="width:38vw;display:flex;margin:0px 0px 0px 0px;justify-content: space-between;align-items:center">
              <div style="display: flex;
                          width: 14vw;
                          justify-content: space-between;
                          align-items: center;
                          font-size: 16px;">
                <span style="color:#666666;">日期</span>
                <el-date-picker
              clearable
                    v-model="planDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择计划日期"
                    @change="searchBtn">
                  </el-date-picker>
              </div>
              <div style="display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 16px;
              width: 17vw;
              "><span style="display:flex;width:4vw;color:#666666;">计划名称</span><el-input @change="searchBtn" clearable v-model="napeId" placeholder="请输入计划名称"></el-input></div>
              <div class="search" @click="searchBtn">查询</div>
              <!-- <el-button @click="addPlan">创建计划</el-button> -->
              <div></div>
            </div>
            <div class="crea"  @click="addPlan">创建计划</div>
            
          </div>
          <div class="build-table">
            <el-table
              
              :data="listData"
              height="100%"
              style="width: 100%;"
              :default-sort="{prop: 'clockTime', order: 'descending'}"
              :row-style="{height:'20px'}"
              :header-cell-style="{textAlign:'start',color:'#909399',fontFamily: 'SourceHanSansCN-Regular',fontSize:'14px',fontWeight: 'normal'}"
              :cell-style="{height:'20px',color: '#666666',fontSize: '12px',fontFamily: 'SourceHanSansCN-Normal'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <span>{{
                     scope.row.index}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="标题">
                <template slot-scope="scope">
                  <span>{{ scope.row.name}}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="计划名称" width="240">
                <template slot-scope="scope">
                  <span>{{ scope.row.napeId}}</span>
                </template>
              </el-table-column>
              <el-table-column label="检查范围" width="170">
                <template slot-scope="scope">
                  <span>{{ scope.row.around }}</span>
                </template>
              </el-table-column>
              <el-table-column label="检查责任单位" width="280">
                <template slot-scope="scope">
                  <span>{{scope.row.entName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="责任人" width="170">
                <template slot-scope="scope">
                  <span>{{ scope.row.userName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计划检查时间" width="180" prop="clockTime">
                <template slot-scope="scope">
                  <span>{{ scope.row.planDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实际检查时间" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.updateDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="检查问题状态" >
                <template slot-scope="scope">
                  <span style="color:#67C23A" v-if="scope.row.qsId!=null&&scope.row.qsId!=''">已巡查</span>
                  <span v-else style="color:#F56C6C">未巡查</span>
                  
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <!-- <el-button type="success" plain size="mini" @click="sumbitInfo(scope.row)" style="margin-top:0.5vh;margin-bottom:0.5vh;">查看</el-button> -->
                  <div style="display: flex;
    justify-content: center;
    align-items: center;">
                    <div style="margin: 0 4px 0 0 " class="chakan"  @click="handleAdd(scope.row)">添加</div>
                    <div class="chakan" v-if="scope.row.qsId==null||scope.row.qsId==''" style="margin: 0 4px 0 0"  @click="handleEdit(scope.row)">编辑</div>
                    <div class="chakan1"  @click="sumbitInfo(scope.row)">查看</div>
                      <div v-if="groupId=='1549310060570570753'" class="chakan1"  @click="removeFun(scope.row)">删除</div>
                  </div>
                </template>
              </el-table-column>
              
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
            <!-- 人员修改 -->
            <el-dialog width="500px" title="添加计划" :visible.sync="modifyVisible" append-to-body>
              <el-form
                :model="workerInfo"
                ref="workerInfo"
                label-width="160px"
                label-position="right"
                :rules="rules"
              >
                <!-- <el-form-item label="标题：" prop="name">
                  <el-input v-model="workerInfo.name" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item> -->
                <el-form-item label="计划名称：" prop="napeId">
                  <!-- <el-select v-model="workerInfo.napeId" placeholder="请选择">
                    <el-option
                      v-for="item in napeList"
                      :key="item.id"
                      :label="item.description"
                      :value="item.id">
                    </el-option>
                  </el-select> -->
                  <el-input v-model="workerInfo.napeId" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="检查范围：" prop="around">
                  <el-input v-model="workerInfo.around" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="检查责任单位：" prop="entId">
                  <el-select v-model="workerInfo.entId" placeholder="请选择">
                    <el-option
                      v-for="item in entList"
                      :key="item.emtId"
                      :label="item.entName"
                      :value="item.emtId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="责任人：" prop="userId">
                  <el-select v-model="workerInfo.userId" @change="aaa()" placeholder="请选择">
                    <el-option
                      v-for="item in personList"
                      :key="item.id"
                      :label="item.personName"
                      :value="item.userId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="计划检查时间：" prop="planDate">
                  <el-date-picker
                    v-model="workerInfo.planDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo('workerInfo')">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../../untils/port.js'
import util from '../../../../untils/util.js'
import base from '../../../../untils/base'
export default {
  data() {
    return {
      listData: [],
      search: {
        //查询
        // name: '',
        // projectId: '',
        // date:util.myTime.getCurTime(),
        // temperatureType:'2',
        // teamsId: '',
        // entId: '',
        // personName: '',
      },
      groupId: '',
      dataText: '数据加载中...',
      
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      modifyVisible: false,
      workerInfo: {
        id: '',
        name:'',
        projectId: '',
        napeId:'',
        around:'',
        entId:'',
        planDate:'',
        userId:''
      },
      rules:{
        name:[
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        napeId:[
          { required: true, message: '请输入计划检查事项', trigger: 'change' },
        ],
        around:[
          { required: true, message: '请输入检查范围', trigger: 'blur' },
        ],
        entId:[
          { required: true, message: '请输入检查责任单位', trigger: 'change' },
        ],
        userId:[
          { required: true, message: '请输入检查责任人', trigger: 'change' },
        ],
        planDate:[
          { required: true, message: '请输入检查时间', trigger: 'blur' },
        ],
        napeId:[
          { required: true, message: '请输入计划名称', trigger: 'blur' },
        ],
      },
      //检查事项列表
      napeList:[],
      //责任单位
      entList:[],
      //责任人
      personList:[],
      planDate:'',
      userName:'',
      napeId:'',
    }
  },
  created() {
    this.groupId = util.session.get('groupId')
    if(this.$route.query.pageSize){
      this.pageSize=this.$route.query.pageSize
      this.currentPage=this.$route.query.currentPage
    }
  },
  mounted() {
    this.search.projectId = this.groupId
    if (this.search.projectId == '') {
      this.$store.commit('setGroupId')
      this.search.projectId = this.$store.state.groupId
    }
    this.getNapeList()
    this.getEntList()
    this.getPerosn()
    this.getData()
  },
  methods: {
  
    removeFun(row){

      // console.log('点击了删除按钮');
      console.log(row);
            var that = this
            let id=row.id
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteProQsPlan({
           id:id,
           delFlag:0
          }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
             
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }).catch(err => { })
    },
    aaa(){
      console.log(this.workerInfo.userId)
    },
    handleAdd(row){
      this.$emit('toAdd', row.id)
      this.$router.push({
        path:'planPro',
        query:{
          pageSize:this.pageSize,
          currentPage:this.currentPage
        }
      })
    },
    handleEdit(row){
      let data = {
        safeId: row.safeId,
        safeItemId: row.safeItemId,
        id: row.id
      }
      this.$emit('toEdit', data)
      this.$router.push({
        path:'planPro',
        query:{
          pageSize:this.pageSize,
          currentPage:this.currentPage
        }
      })
    },
    //获取事项
    getNapeList(){
      var that = this
      myHttp.selectProQsNapeListByProjectId({
        projectId:this.groupId
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.proQsNapes||[]
          that.napeList = list
        }
      })
    },
    //责任单位
    getEntList(){
      var that = this
      myHttp.getProjectEntByProjectId({
          projectId:this.groupId
      }).then(function(resp){
          if (resp.data.code == '200'){
              var list = resp.data.data.projectEnt || []
              that.entList = list
          }
      })
    },
    //获取人员
    getPerosn(){
      var that = this
      myHttp
          .findProjectUserPage({
            projectId: util.session.get('groupId'),
            pageNum:1,
            pageSize:1000
          })
          .then(function (resp) {
            console.log(resp);
            if (resp.data.code == '200') {
              that.personList = resp.data.data.projectUserPage.list
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      // myHttp.getRoleUserList({
      //   userType:util.session.get('roleId'),
      //   groupId:this.groupId
      // }).then(function(resp){
      //   if(resp.data.code=="200"){
      //       var list = resp.data.data.users||[];
      //       that.personList = list;
      //       console.log(that.personList)
      //   }
      // },function(){});
    },
    //
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.listData = []
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      // this.search.delFlag=0
      myHttp.selectProQsPlanPage(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for(var i=0;i<list.length;i++){
              list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
            }
            that.listData = list
            that.listData.reverse()
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }else{
              that.totalItems = resp.data.data.pageInfo.total||0
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    searchBtn(){
      var that = this
      this.listData = []
      this.search.planDate = this.planDate
      this.search.napeId =this.napeId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.selectProQsPlanPage(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for(var i=0;i<list.length;i++){
              list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
            }
            that.listData = list
            that.listData.reverse()
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }else{
              that.totalItems = resp.data.data.pageInfo.total||0
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }

        },
        function() {}
      )
    },
    //添加计划
    addPlan(){
      this.modifyVisible = true
      this.workerInfo.napeId = ''
      this.workerInfo.around = ''
      this.workerInfo.entId = ''
      this.workerInfo.planDate = ''
      this.workerInfo.userId = ''
    },
    
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    /**
     * 提交
     */
    modifyWorkerInfo(formName){
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.workerInfo.projectId = this.groupId
          myHttp.createProQsPlan(that.workerInfo).then(function(resp){
            console.log(resp)
            if(resp.data.code=='200'){
              that.$message.success('提交成功')
              that.modifyVisible = false
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    /**
     * 查看
     */
    sumbitInfo(row){
      console.log(row)
      row.qsId = row.qsId||''
      if(row.qsId==''){
        this.$message({
          type:'error',
          message:'暂无巡查记录！'
        })
        return
      }
      let pageSize = this.pageSize
      let currentPage = this.currentPage
      util.session.set('params',{pageSize:pageSize,currentPage:currentPage})
      this.$router.push({ name: 'qsDetail', params: { id: row.qsId ,type:row.type,handle:'1'} })
    },

  }
}
</script>
<style>
  @import '../../../../assets/css/common.css';
</style>
<style scoped>
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }
  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }
  .contentA >>> .el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }
  .contentA{
    width: 100%;
    height: 84vh;
  }
  ::v-deep.el-table--border, .el-table--group {
    border: 1px solid #EBEEF5;
}
  .build-table {
    height: calc(100% - 100px);
    padding: 1vh;
    position: relative;
    margin-top: 5px;
  }
  .cur{
    background: #ECF5FF !important;
    color:#409EFF !important  ;
  }
  div >>> .el-dialog__header {
    padding: 20px 20px 10px;
    text-align: center !important;
  }
  .send >>> .el-dialog__header {
    text-align: left !important;
  }
  div >>> .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: center;
    box-sizing: border-box;
  }
  div >>>.el-input-group--append .el-input__inner{
    width: 200px;
    height: 33px;
  }
  .dialog_send{
    margin:10px 0px 10px 35px;
  }
  .dialog_end{
    padding:30px 0px 10px 35px;
    display: flex;
    justify-content: flex-end;
  }
  .else{
    justify-content: space-between;
    border-top: 1px dotted #ECF5FF;
  }
  .tips{
        display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
  }
  .search{
    width: 80px;
    height: 32px;
    border-radius: 6px;
    background: #FDFEFE;
    box-sizing: border-box;
    border: 1px solid rgba(153, 153, 153, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
  }
  .search:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .crea{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
height: 32px;
border-radius: 6px;
background: #FDFEFE;
box-sizing: border-box;
border: 1px solid rgba(153, 153, 153, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
  }
  .crea:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .chakan{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid rgba(142, 163, 206, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #8EA3CE;
  }
    .chakan1{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid #F7A7A7;;
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #F7A7A7;;
  }
  .chakan:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .chakan1:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  ::v-deep .el-table th.el-table__cell>.cell{
    font-size: 14px !important;
  }
  ::v-deep .cell>span{
    font-size: 14px !important;
    text-align: start !important;
  }
  ::v-deep .cell{
    font-size: 14px !important;
    text-align: start  !important;
  }
  ::v-deep .el-input__inner{
    height: 33px;
  }
  ::v-deep .el-pagination{
    padding: 0;
    padding-top:1.2vh ;
  }
</style>